import { render, staticRenderFns } from "./aggregateChat.vue?vue&type=template&id=5f5708d4"
import script from "./aggregateChat.vue?vue&type=script&lang=js"
export * from "./aggregateChat.vue?vue&type=script&lang=js"
import style0 from "./aggregateChat.vue?vue&type=style&index=0&id=5f5708d4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports